import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import api from "@/lib/api";
import { IMG } from "@/lib/brand";
import { Section, PageHeader } from "@/components/common";

export function Actualites() {
  const [items, setItems] = useState([]);
  useEffect(() => {
    api.get("/news").then((r) => setItems(r.data)).catch(() => {});
  }, []);
  return (
    <div data-testid="news-page">
      <PageHeader eyebrow="Actualités" title="Le journal" subtitle="Sorties, sessions studio, coulisses et annonces d'AL Music Records." image={IMG.vinyl} />
      <Section className="py-20">
        {items.length === 0 ? (
          <div className="card-dark p-10 text-center text-slate-500 text-sm"><span className="font-mono text-xs uppercase tracking-widest text-amber-300">À compléter</span><p className="mt-3">Les articles publiés apparaîtront ici.</p></div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {items.map((n) => (
              <Link key={n.id} to={`/actualites/${n.slug}`} data-testid={`news-${n.slug}`} className="card-dark overflow-hidden group">
                <div className="aspect-video overflow-hidden bg-[#1A1A20]">{n.image && <img src={n.image} alt={n.title} className="w-full h-full object-cover group-hover:scale-105 transition duration-500" />}</div>
                <div className="p-6">
                  <div className="flex items-center gap-3">
                    {n.category && <span className="eyebrow">{n.category}</span>}
                    {n.date && <span className="text-xs text-slate-600">{n.date}</span>}
                  </div>
                  <h3 className="font-display font-bold text-lg mt-2">{n.title}</h3>
                  <p className="text-sm text-slate-500 mt-2 line-clamp-2">{n.summary}</p>
                </div>
              </Link>
            ))}
          </div>
        )}
      </Section>
    </div>
  );
}

export function ActualiteDetail() {
  const { slug } = useParams();
  const [item, setItem] = useState(undefined);
  useEffect(() => {
    api.get(`/news/${slug}`).then((r) => setItem(r.data)).catch(() => setItem(null));
  }, [slug]);
  if (item === undefined) return null;
  if (item === null) return <Section className="py-32 text-center"><h1 className="font-display text-3xl">Article introuvable</h1><Link to="/actualites" className="btn-ghost mt-6 inline-flex">Retour</Link></Section>;
  return (
    <div data-testid="news-detail-page">
      <PageHeader eyebrow={item.category || "Actualité"} title={item.title} subtitle={item.summary} image={item.image || IMG.vinyl} />
      <Section className="py-20 max-w-3xl">
        <div className="flex items-center gap-4 text-sm text-slate-500 mb-8">
          {item.date && <span>{item.date}</span>}
          {item.author && <span>· Par {item.author}</span>}
        </div>
        <div className="prose prose-invert text-slate-300 leading-relaxed whitespace-pre-line">{item.content}</div>
        <Link to="/actualites" className="btn-ghost mt-12 inline-flex">← Retour aux actualités</Link>
      </Section>
    </div>
  );
}
